import { clearSession } from "./session";

// Logout is entirely client-side by design: the backend intentionally
// exposes no /api/auth/logout/ (no server-side token revocation), so
// "logging out" just means discarding everything we hold locally.
export const logoutUser = () => {
  clearSession();
  localStorage.removeItem("isAuthenticated");
  localStorage.removeItem("userEmail");
  sessionStorage.clear();
  window.location.replace("/");
};
